// ----------------------------------------------------------------------

const shape = {
  borderRadius: 6,
  borderRadiusSm: 10,
  borderRadiusMd: 14
};

export default shape;
